import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-275ef379"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "loading-top-account-spinner"
};
const _hoisted_2 = ["textContent"];
const _hoisted_3 = {
  class: "workspace"
};
const _hoisted_4 = {
  class: "top-account-browse-icon"
};
const _hoisted_5 = ["textContent"];
const _hoisted_6 = {
  class: "top-account-div"
};
const _hoisted_7 = {
  class: "quicksearchelement"
};
const _hoisted_8 = {
  key: 0,
  class: "top-account-settings"
};
const _hoisted_9 = {
  class: "top-account-settings-panel"
};
const _hoisted_10 = {
  class: "top-account-info"
};
const _hoisted_11 = ["textContent"];
const _hoisted_12 = {
  class: "info"
};
const _hoisted_13 = {
  class: "workspace"
};
const _hoisted_14 = {
  class: "members"
};
const _hoisted_15 = {
  class: "top-account-settings-btn"
};
const _hoisted_16 = {
  class: "option"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  class: "text"
};
const _hoisted_19 = {
  class: "top-account-name-list"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["textContent"];
const _hoisted_22 = {
  class: "workspace-list-name-style"
};
const _hoisted_23 = {
  class: "account-summary-dashboard"
};
const _hoisted_24 = {
  class: "account-summary-icon"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "account-summary-dashboard-text"
}, "Accounts summary dashboard", -1));
const _hoisted_26 = {
  key: 1,
  class: "top-account-management"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add account", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Manage accounts", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_custom_account_quick_search_element = _resolveComponent("custom-account-quick-search-element");
  const _component_feature = _resolveComponent("feature");
  return _openBlock(), _createElementBlock("div", {
    class: "d-flex align-items-center topbar",
    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
  }, [$data.topAccountNameLoading ? (_openBlock(), _createElementBlock("div", _hoisted_1)) : _createCommentVNode("", true), !$data.topAccountNameLoading && !$props.isCollapsed | $props.isHovering ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.toggleTopAccountListView && $options.toggleTopAccountListView(...args), ["stop"])),
    class: _normalizeClass(["top-account-name-style", ['top-account-name-style', {
      'show-top-account-list-view': $props.showTopAccountListView
    }]])
  }, [_createElementVNode("div", {
    class: "top-account-icon-style",
    textContent: _toDisplayString($options.firstLetterOfWorkspace)
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, _toDisplayString($options.workspaceName), 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_app_icon, {
    icon: "chevron-up-down-new-ui"
  })])], 2)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => $options.toggleTopAccountListView && $options.toggleTopAccountListView(...args), ["stop"])),
    class: "top-account-name-style-collapse"
  }, [_createElementVNode("div", {
    class: "top-account-icon-style",
    textContent: _toDisplayString($options.firstLetterOfWorkspace)
  }, null, 8, _hoisted_5)], 512), [[_vShow, !$data.topAccountNameLoading && $props.isCollapsed && !$props.isHovering]]), !$data.topAccountNameLoading && $props.showTopAccountListView && !$props.isCollapsed | $props.isHovering ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: _normalizeClass(["top-account-list-view", {
      'padding-bottom': !_ctx.isOmnyAdmin && !_ctx.isOmnyUser
    }])
  }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_custom_account_quick_search_element, {
    placeholder: $options.searchPlaceHolder,
    value: $data.searchQuery,
    onSearch: $options.handleAccountSearch,
    onHandleSearchBarBlured: $options.handleSearchBarBlured,
    onHandleSearchBarFocused: $options.handleSearchBarFocused
  }, null, 8, ["placeholder", "value", "onSearch", "onHandleSearchBarBlured", "onHandleSearchBarFocused"])])]), !$data.isSearchBarFocused ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
    class: "top-account-icon-style",
    textContent: _toDisplayString($options.firstLetterOfWorkspace)
  }, null, 8, _hoisted_11), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString($options.workspaceName), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.members.length) + " members", 1)]), _createVNode(_component_app_icon, {
    icon: "account-check",
    color: "var(--market-950)"
  })]), _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.accountSettingOptions, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_feature, {
      name: item.featureName
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: "setting",
        onClick: () => $options.onAccountSettingClick(item)
      }, [_createVNode(_component_app_icon, {
        icon: item.icon
      }, null, 8, ["icon"]), _createElementVNode("span", _hoisted_18, _toDisplayString(item.text), 1)], 8, _hoisted_17)]),
      _: 2
    }, 1032, ["name"])]);
  }), 256))])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sortedWorkspaces, workspace => {
    return _openBlock(), _createElementBlock("div", {
      class: "top-account-name-list-style",
      key: workspace.workspace_id,
      onClick: $event => $options.onCurrentChange(workspace.workspace_id)
    }, [_createElementVNode("div", {
      class: "top-account-list-icon-style",
      textContent: _toDisplayString(workspace.firstLetter),
      style: _normalizeStyle({
        backgroundColor: $data.colors[workspace.colorIndex]
      })
    }, null, 12, _hoisted_21), _createElementVNode("div", _hoisted_22, _toDisplayString(workspace.workspace_name), 1)], 8, _hoisted_20);
  }), 128))]), _createVNode(_component_feature, {
    name: "accountSummaryDashboard"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", {
      class: "account-summary-dashboard-btn",
      onClick: _cache[2] || (_cache[2] = (...args) => $options.navigateToBrandPortfolio && $options.navigateToBrandPortfolio(...args))
    }, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_app_icon, {
      icon: "account-summary-dashboard",
      color: "var(--color-semantic-blue-800)"
    })]), _hoisted_25])])]),
    _: 1
  }), _ctx.isOmnyAdmin || _ctx.isOmnyUser ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_ctx.isOmnyAdmin ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "add-account-btn",
    onClick: _cache[3] || (_cache[3] = $event => $options.navigateToAddAccount())
  }, [_createVNode(_component_app_icon, {
    icon: "add-account-icon"
  }), _hoisted_27])) : _createCommentVNode("", true), _ctx.isOmnyAdmin || _ctx.isOmnyUser ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "manage-account-btn",
    onClick: _cache[4] || (_cache[4] = $event => $options.navigateToManageAccount())
  }, [_createVNode(_component_app_icon, {
    icon: "manage-account-icon"
  }), _hoisted_28])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)]);
}